/** The discount amount, with "% off" or "$ … off" around it. Only digits (and a point for dollars) get in. */
import { TicketSalesCampaignDiscountType } from '@bonsai/shared';

import { fieldBoxStyle } from '../../../shared/date-time-range/picker-styles';
import { cleanDiscountText } from '../../../utils/discount-amount-text';

export interface CampaignAmountInputProps {
  discountType: TicketSalesCampaignDiscountType;
  value: string;
  error?: string;
  onChange: (amount: string) => void;
}

const affixStyle = { color: 'var(--nb-subtle)', fontWeight: 700, flex: '0 0 auto' } as const;

export function CampaignAmountInput({
  discountType,
  value,
  error,
  onChange,
}: CampaignAmountInputProps) {
  const flat = discountType === TicketSalesCampaignDiscountType.FLAT;
  return (
    <label style={{ ...fieldBoxStyle(false, Boolean(error)), width: 150 }}>
      {flat && <span style={affixStyle}>$</span>}
      <input
        aria-label={flat ? 'Dollars off each ticket' : 'Percent off each ticket'}
        aria-describedby={error ? 'campaign-amount-error' : undefined}
        aria-invalid={Boolean(error)}
        inputMode={flat ? 'decimal' : 'numeric'}
        value={value}
        placeholder={flat ? '10.00' : '20'}
        onChange={(e) => onChange(cleanDiscountText(discountType, e.target.value))}
        style={{
          flex: 1,
          minWidth: 0,
          border: 0,
          outline: 'none',
          background: 'transparent',
          fontSize: 15,
          fontWeight: 700,
          fontVariantNumeric: 'tabular-nums',
          color: 'var(--nb-ink)',
        }}
      />
      <span style={affixStyle}>{flat ? 'off' : '% off'}</span>
    </label>
  );
}
